<template>
  <div class="news" v-if="$root.dataReady">
    <newsletter-modal></newsletter-modal>
    <header
      class="heading heading--bg-news heading--desktop"
      :class="page.acf.hero_picture_position"
      :style="{
        'background-image': 'url( ' + hero_featured_img.source_url + ' )',
      }"
    >
      <div
        class="container"
        :class="[{ 'dark-theme': page.acf.featured_news_theme == true }]"
      >
        <div class="text">
          <span
            class="date"
            v-html="formatDate(page.acf.featured_news.post_date)"
          ></span>
          <h1 v-html="page.acf.featured_news.post_title"></h1>
          <p>
            <a
              class="btn"
              :href="page.acf.featured_news.guid"
              v-html="page.acf.button_label"
            ></a>
          </p>
        </div>
        <div class="bg-news"></div>
        <div class="mouse-icon-container">
          <a class="scroll-down-section" v-on:click="scrollToNextSection()">
            <div class="mouse-icon">
              <span class="mouse-wheel"></span>
            </div>
          </a>
        </div>
      </div>
    </header>
    <header
      class="heading heading--bg-news heading--mobile"
      :class="page.acf.hero_picture_position"
      :style="{
        'background-image': 'url( ' + hero_featured_img_mobile + ' )',
      }"
    >
      <div
        class="container"
        :class="[{ 'dark-theme': page.acf.featured_news_theme == true }]"
      >
        <div class="text">
          <span
            class="date"
            v-html="formatDate(page.acf.featured_news.post_date)"
          ></span>
          <h1 v-html="page.acf.featured_news.post_title"></h1>
          <p>
            <a
              class="btn"
              :href="page.acf.featured_news.guid"
              v-html="page.acf.button_label"
            ></a>
          </p>
        </div>
        <div class="bg-news"></div>
        <div class="mouse-icon-container">
          <a class="scroll-down-section" v-on:click="scrollToNextSection()">
            <div class="mouse-icon">
              <span class="mouse-wheel"></span>
            </div>
          </a>
        </div>
      </div>
    </header>
    <div class="buttons">
      <span class="title" v-html="page.acf.news_filter_label"></span>
      <a
        v-on:click="resetFilter()"
        :class="['btn default', { active: catNumber === 0 }]"
        v-html="page.acf.news_all_label"
      ></a>
      <a
        v-for="(category, i) in categories"
        v-on:click="loadCategoryPosts(category.id)"
        :key="i"
        :class="[
          'btn default',
          category.slug,
          { active: catNumber == category.id },
        ]"
        >{{ category.name }}</a
      >
    </div>
    <!-- content from wp-api -->
    <div class="posts">
      <div class="container">
        <div class="content">
          <newsletter-button></newsletter-button>

          <div class="row no-margin wrapper">
            <template v-for="(post, index) in posts">
              <!--  count slides form 0, 1 ,2 && not pdf file -->
              <!-- slide 0, 3, 6 -->
              <div
                class="news-layout-wrapper row-element col-l-12 col-m-12 col-s-12"
                v-if="!post.acf.pdf_file"
                :key="`${index}-x`"
                v-on:click="getLastElementPosition"
              >
                <router-link
                  tag="a"
                  class="post"
                  :to="{
                    path:
                      '/' +
                      post.pure_taxonomies.categories[0].slug +
                      '/' +
                      post.slug,
                  }"
                >
                  <div class="row no-margin news-layout-item">
                    <div class="image row-element col-l-6 col-m-6 col-s-12">
                      <div
                        v-if="post.better_featured_image && index % 2 == 0"
                        class="bg notched notched__enabled notched__inside notched__mobile-outside notched--top notched--mobile-middle notched--white"
                        :class="post.acf.large_picture_position"
                        :style="[
                          post.better_featured_image
                            ? {
                                'background-image':
                                  'url( ' +
                                  post.better_featured_image.source_url +
                                  ' )',
                              }
                            : {},
                        ]"
                      >
                        <div class="notched-helper"></div>
                      </div>
                      <div
                        v-else
                        class="bg notched notched__enabled notched__outside notched__mobile-outside notched--top notched--mobile-middle notched--white"
                        :class="post.acf.large_picture_position"
                        :style="[
                          post.better_featured_image
                            ? {
                                'background-image':
                                  'url( ' +
                                  post.better_featured_image.source_url +
                                  ' )',
                              }
                            : {},
                        ]"
                      >
                        <div class="notched-helper"></div>
                      </div>
                    </div>
                    <div class="row-element col-l-6 col-m-6 col-s-12">
                      <div class="text">
                        <div class="sub-title">
                          <div
                            v-for="(category, i) in post.pure_taxonomies
                              .categories"
                            :key="i"
                            :class="['type', category.category_nicename]"
                          >
                            {{ category.name }}
                          </div>
                          <div class="date">{{ formatDate(post.date) }}</div>
                        </div>
                        <div class="title" v-html="post.title.rendered"></div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>

              <!-- slide 0, 3, 6 && pdf file-->
              <div
                class="news-layout-wrapper row-element col-l-12 col-m-12 col-s-12"
                v-if="post.acf.pdf_file"
                :key="`${index}-y`"
                v-on:click="getLastElementPosition"
              >
                <router-link
                  tag="a"
                  class="post"
                  :to="{
                    path:
                      '/' +
                      post.pure_taxonomies.categories[0].slug +
                      '/' +
                      post.slug,
                  }"
                >
                  <div class="row no-margin news-layout-item">
                    <div class="image row-element col-l-6 col-m-6 col-s-12">
                      <div
                        v-if="post.better_featured_image && index % 2 == 0"
                        class="bg notched notched__enabled notched__inside notched__mobile-outside notched--top notched--mobile-middle notched--white"
                        :class="post.acf.large_picture_position"
                        :style="[
                          post.better_featured_image
                            ? {
                                'background-image':
                                  'url( ' +
                                  post.better_featured_image.source_url +
                                  ' )',
                              }
                            : {},
                        ]"
                      >
                        <div class="notched-helper"></div>
                      </div>
                      <div
                        v-else
                        class="bg notched notched__enabled notched__outside notched__mobile-outside notched--top notched--mobile-middle notched--white"
                        :class="post.acf.large_picture_position"
                        :style="[
                          post.better_featured_image
                            ? {
                                'background-image':
                                  'url( ' +
                                  post.better_featured_image.source_url +
                                  ' )',
                              }
                            : {},
                        ]"
                      >
                        <div class="notched-helper"></div>
                      </div>
                    </div>
                    <div class="row-element col-l-6 col-m-6 col-s-12">
                      <div class="text">
                        <div class="sub-title">
                          <div
                            v-for="(category, i) in post.pure_taxonomies
                              .categories"
                            :key="i"
                            :class="['type', category.category_nicename]"
                          >
                            {{ category.name }}
                          </div>
                          <div class="date">{{ formatDate(post.date) }}</div>
                        </div>
                        <div class="title" v-html="post.title.rendered"></div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </template>
          </div>
          <div class="button">
            <a
              v-if="!hideMore"
              v-on:click="loadMorePosts()"
              class="btn default"
              v-html="page.acf.news_show_more_button"
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import NewsletterModal from "../components/NewsletterModal";
import NewsletterButton from "../components/NewsletterButton";
export default {
  name: "news-page",
  props: ["slug"],
  data() {
    return {
      posts: null,
      perpage: 30,
      postoffset: 0,
      hideMore: false,
      isFiltered: false,
      catNumber: parseInt(this.getCurrentCategory()) || 0,
      categories: null,
      pagecontent: null,
      page: null,
      hero_featured_img: null,
      hero_featured_img_mobile: null,
    };
  },
  created: function () {
    this.fetchData();
    this.$root.dataReady = false;
  },
  methods: {
    fetchData: function () {
      var self = this,
        pageNumber;

      $.get(
        self.$root.apiUrl +
          "wp-json/wp/v2/pages?slug=" +
          (self.slug === undefined ? "news" : self.slug),
        function (response) {
          self.pagecontent = response[0].content.rendered;
          if (response[0].acf.featured_news_theme) {
            self.$root.headeriswhite = false;
          } else {
            self.$root.headeriswhite = true;
          }
          self.setTitle(response[0].title.rendered);
          self.page = response[0];

          $.get(
            self.$root.apiUrl +
              "wp-json/wp/v2/posts/" +
              response[0].acf.featured_news.ID,
            function (response) {
              self.hero_featured_img = response.better_featured_image;
              self.hero_featured_img_mobile =
                response.acf.mobile_featured_image;
            }
          );
        }
      )
        .done(function () {})
        .fail(function () {});
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/categories",
        function (response) {
          self.categories = response;
        }
      )
        .done(function () {
          setTimeout(function () {
            self.setSessionStorage();
            self.setCurrentCategory();
            this.isFiltered = true;
            let request = "";
            if (self.catNumber !== 0) {
              request =
                self.$root.apiUrl +
                "wp-json/wp/v2/posts?per_page= " +
                self.perpage * self.getShowMorePageNumber() +
                "&exclude=" +
                self.page.acf.featured_news.ID +
                "&offset=" +
                self.postoffset +
                "&categories=" +
                self.catNumber;
            } else {
              pageNumber = JSON.parse(sessionStorage.getItem("currentPage"))[0]
                .showMorePage;
              request =
                self.$root.apiUrl +
                "wp-json/wp/v2/posts?per_page= " +
                self.perpage * pageNumber +
                "&exclude=" +
                self.page.acf.featured_news.ID +
                "&offset=" +
                self.postoffset;
            }
            $.get(request, function (response) {
              self.posts = response;
              self.setTitle("News");
              self.$root.dataReady = true;
              if (response.length < self.perpage) {
                self.hideMore = true;
              } else {
                self.hideMore = false;
              }
            })
              .done(function () {
                setTimeout(function () {
                  self.scrollToLastElement();
                }, 1000);
              })
              .fail(function () {});
          }, 500);
        })
        .fail(function () {});
    },
    formatDate: function (date) {
      date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
      var mydate = new Date(date);
      var month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ][mydate.getMonth()];
      return month + " " + mydate.getDate() + ", " + mydate.getFullYear();
    },
    loadMorePosts: function () {
      if (!this.isFiltered) {
        this.postoffset += this.perpage;
        this.postoffset++;
        var self = this;
        $.get(
          self.$root.apiUrl +
            "wp-json/wp/v2/posts?per_page= " +
            self.perpage +
            "&offset=" +
            self.postoffset,
          function (response) {
            if (response.length < self.perpage) {
              self.hideMore = true;
            } else {
              self.hideMore = false;
            }
            for (var i = 0; i < response.length; i++) {
              self.posts.push(response[i]);
            }
          }
        )
          .done(function () {
            self.addToSessionStorage();
          })
          .fail(function () {});
      } else {
        this.postoffset += this.perpage;
        var self = this;
        $.get(
          self.$root.apiUrl +
            "wp-json/wp/v2/posts?per_page= " +
            self.perpage +
            "&offset=" +
            self.postoffset +
            "&categories=" +
            self.catNumber,
          function (response) {
            if (response.length < self.perpage) {
              self.hideMore = true;
            } else {
              self.hideMore = false;
            }
            for (var i = 0; i < response.length; i++) {
              self.posts.push(response[i]);
            }
          }
        )
          .done(function () {
            self.addToSessionStorage();
          })
          .fail(function () {});
      }
    },
    loadCategoryPosts: function (number) {
      this.isFiltered = true;
      this.catNumber = number;
      this.postoffset = 0;
      var self = this;
      this.resetOffsetAndPages();
      $.get(
        self.$root.apiUrl +
          "wp-json/wp/v2/posts?per_page=" +
          self.perpage * this.getShowMorePageNumber() +
          "&offset=" +
          self.postoffset +
          "&categories=" +
          self.catNumber,
        function (response) {
          self.posts = response;

          if (response.length < self.perpage) {
            self.hideMore = true;
          } else {
            self.hideMore = false;
          }
        }
      )
        .done(function () {
          self.scrollToLastElement();
          self.setCurrentCategory();
        })
        .fail(function () {});
    },
    resetFilter: function () {
      this.postoffset = 0;
      this.hideMore = false;
      this.isFiltered = false;
      this.catNumber = 0;
      this.fetchData();
      this.setCurrentCategory();
      this.resetOffsetAndPages();
    },
    setCurrentCategory: function () {
      sessionStorage.setItem("currentCategory", this.catNumber);
    },
    getCurrentCategory: function () {
      return sessionStorage.getItem("currentCategory");
    },
    setSessionStorage: function () {
      if (!sessionStorage.getItem("currentPage")) {
        let arrayOfCatSettings = [],
          catAll = {
            id: 0,
            name: "All",
            showMorePage: 1,
            offset: 0,
          };

        arrayOfCatSettings.push(catAll);

        this.categories.forEach((item) => {
          let obj = {
            id: item.id,
            name: item.name,
            showMorePage: 1,
            offset: 0,
          };
          arrayOfCatSettings.push(obj);
        });

        sessionStorage.setItem(
          "currentPage",
          JSON.stringify(arrayOfCatSettings)
        );
      }
    },
    addToSessionStorage: function () {
      //       if (sessionStorage.getItem("currentPage")) {
      //         let currentValue = JSON.parse(sessionStorage.getItem("currentPage")),
      //           arrayIndex = this.getArrayElementIndex();
      //
      //         currentValue[arrayIndex].showMorePage += 1;
      //         sessionStorage.setItem("currentPage", JSON.stringify(currentValue));
      //       }
    },
    getArrayElementIndex: function () {
      const currentValue = JSON.parse(sessionStorage.getItem("currentPage")),
        number = currentValue.findIndex((element) => {
          return element.id === parseInt(this.catNumber);
        });
      // console.log(number);
      return number !== -1 ? number : 0;
    },
    resetSessionStorage: function () {
      if (sessionStorage.getItem("currentPage")) {
        sessionStorage.removeItem("currentPage");
      }
    },
    scrollToLastElement: function () {
      //       if (sessionStorage.getItem("currentPage")) {
      //         let currentValue = JSON.parse(sessionStorage.getItem("currentPage")),
      //           arrayIndex = this.getArrayElementIndex(),
      //           offsetValue = currentValue[arrayIndex].offset;
      //
      //         if (offsetValue > 0) {
      //           window.scrollTo({
      //             left: 0,
      //             top: offsetValue,
      //             behavior: "smooth"
      //           });
      //         }
      //       }
    },
    scrollToNextSection: function () {
      window.scrollTo({
        left: 0,
        top: $(window).height(),
        behavior: "smooth",
      });
    },
    resetOffsetAndPages: function () {
      if (sessionStorage.getItem("currentPage")) {
        let currentValue = JSON.parse(sessionStorage.getItem("currentPage"));

        for (let i in currentValue) {
          currentValue[i].offset = 0;
          currentValue[i].showMorePage = 1;
        }
        sessionStorage.setItem("currentPage", JSON.stringify(currentValue));
      }
    },
    getLastElementPosition: function (e) {
      let currentValue = JSON.parse(sessionStorage.getItem("currentPage")),
        arrayIndex = this.getArrayElementIndex();

      currentValue[arrayIndex].offset = parseInt(e.pageY - 250);
      sessionStorage.setItem("currentPage", JSON.stringify(currentValue));
    },
    getShowMorePageNumber: function () {
      const arrayIndex = this.getArrayElementIndex(),
        currentValue = JSON.parse(sessionStorage.getItem("currentPage"));
      return currentValue[arrayIndex].showMorePage;
    },
    setTitle: function (title) {
      title = title.normalize("NFD").replace("&#038;", "&");
      document.title = title + " - Weber Shandwick";
    },
  },
  components: {
    NewsletterModal,
    NewsletterButton,
  },
};
</script>



// WEBPACK FOOTER //
// News.vue?1919ce9c